import { SupabaseClient, createClient } from "@supabase/supabase-js";
import { MakeInjectable } from "../DependencyInjection/DependencyInjection";
import { Database } from "./supabase";

export class SupabaseService {
    supabaseInstance: SupabaseClient<Database, "public">
    public get instance() {
        return this.supabaseInstance;
    }

    constructor() {
        const supabaseUrl = 'https://ykmpgqcwhlivtlsbwmfz.supabase.co';
        this.supabaseInstance = createClient<Database>(supabaseUrl, "sb_publishable_syYue1BrmdBh-0xWQzSg1g_PHb3NHOT")
    }
}

MakeInjectable(SupabaseService, []);